'use strict';

var React = require('react');

var SvgTextColorMajor = function SvgTextColorMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a.75.75 0 0 1 .686.447l4.2 9.5a.75.75 0 1 1-1.372.606l-1.35-3.053h-4.328l-1.35 3.053a.75.75 0 0 1-1.372-.606l4.2-9.5a.75.75 0 0 1 .686-.447Zm-1.5 6h3l-1.5-3.395-1.5 3.395Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.075 16.25a.75.75 0 0 1 .75-.75h12.35a.75.75 0 0 1 0 1.5h-12.35a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgTextColorMajor.displayName = "TextColorMajor";

exports.SvgTextColorMajor = SvgTextColorMajor;
